module.exports = __webpack_public_path__ + "fonts/Pretendard-SemiBold.82658a4c.woff";